import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 14"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M11.5 5a2.5 2.5 0 1 0-2.469-2.104L4.297 5.263a2.5 2.5 0 1 0 0 3.475l4.734 2.366a2.5 2.5 0 1 0 .671-1.341L4.97 7.396a2.5 2.5 0 0 0 0-.792l4.733-2.367c.455.47 1.092.763 1.798.763",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const interfaceShare = { render };
export {
  interfaceShare as default,
  render
};
//# sourceMappingURL=interface-share.svg.js.map
